export const environment = {
    production: true,
    version: '2.0.0',
    // Local
    localApiUrl: 'http://localhost:8000',
    // QA
    apiUrl: 'https://services.wegoshare.com/v3', 
    apiKey: '164b6395-785c-41f2-b52c-582310b2c6fa',
    webSocket: 'wss://services.wegoshare.com/v3/busdata/ws',
    //Configuration
    numberOfButtons: 4,
    buttonsNames: ['Botão TUB', 'Botão WC', 'Botão Cais 12', 'Botão Cais 19'],
    buttonsIdentifiers: ['E663AC91D3656232', 'E663B035971F9723', 'E6614103E74E7E37', 'E6647C15677B2430'],
    alertTimeMin: 5,
    clockButton: false
};
